import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Users
const UserResetPass = () => import('@/views/users/UserResetPass')
const UserAdd = () => import('@/views/users/UserAdd')
const UserUpdate = () => import('@/views/users/UserUpdate')
const UsersList = () => import('@/views/users/UsersList')
const UserProfile = () => import('@/views/users/UserProfile')
const UserLogin = () => import('@/views/users/UserLogin')
const UserVerifyOTP = () => import('@/views/users/UserConfirmOTP')
const UserRegister = () => import('@/views/users/UserRegister')
const CategoryList = () => import('@/views/users/CategoryList')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const PageNoConfigUser = () => import('@/views/pages/PageNoConfigUser')

// Devices : Quản lý thiết bị
const DeviceList = () => import('@/views/devices/List')          /* Thiết bị */

const PiActionConfigList = () => import('@/views/pi_action_config/List')
const PiActionConfigAdd = () => import('@/views/pi_action_config/Add')
const PiActionConfigUpdate = () => import('@/views/pi_action_config/Update')

const UserActionLogList = () => import('@/views/administration/UserActionLogList') /* Nhật ký hành động */
const ThreadList = () => import('@/views/administration/ThreadList')


/* ----- Quản lý nội dung ----- */
const ScreenFileList = () => import('@/views/file-management/FileList')              /* Danh sách bản tin bảng tin */
const ScreenFileAdd = () => import('@/views/file-management/FileAdd')                 /* Biên tập bảng tin */
const PlayList = () => import('@/views/file-management/PlayList')  /* Danh sách phát */
const PlayListAdd = () => import('@/views/file-management/PlayListAdd')  /* Thêm mới danh sách phát */
const PlayListUpdate = () => import('@/views/file-management/PlayListUpdate')  /* Cập nhật danh sách phát */

/* ----- SlideShow ----- */
const SlideShowList = () => import('@/views/slide_show/SlideShowList')  /* Danh sách trình diễn */
const SlideShowAdd = () => import('@/views/slide_show/SlideShowAdd')  /* Thêm mới trình diễn */
const SlideShowUpdate = () => import('@/views/slide_show/SlideShowUpdate')  /* Cập nhật trình diễn */

const ConfigSlideShowList = () => import('@/views/slide_show/central/ConfigSlideShowList')  /* Danh sách cấu hình trình diễn */
const ConfigSlideShowAdd = () => import('@/views/slide_show/central/ConfigSlideShowAdd')  /* Thêm mới cấu hình trình diễn */
const ConfigSlideShowUpdate = () => import('@/views/slide_show/central/ConfigSlideShowUpdate')  /* Cập nhật cấu hình trình diễn */


/* ----- Quản lý lịch phát ----- */
const ScheduleList = () => import('@/views/schedule/List')
const ScheduleAdd = () => import('@/views/schedule/Add')
const ScheduleDetailList = () => import('@/views/schedule_detail/List')
const HistoryList = () => import('@/views/history/List')

//Organization
const OrgList = () => import('@/views/organization/OrgList')
const OrgAdd = () => import('@/views/organization/OrgAdd')
const OrgUpdate = () => import('@/views/organization/OrgUpdate')

//License
const LicenseList = () => import('@/views/license/List')
const LicenseAdd = () => import('@/views/license/Add')

//NotificationList: Thông báo
const NotificationList = () => import('@/views/notification/NotificationList')

//Widget: Tiện ích
const WidgetList = () => import('@/views/widget/WidgetList')
const WidgetAdd = () => import('@/views/widget/WidgetAdd')
const WidgetUpdate = () => import('@/views/widget/WidgetUpdate')
const WidgetOrg = () => import('@/views/widget/WidgetOrgList')

Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Trang chủ',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Trang chủ',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/devices-management',
          redirect: '/devices-management/list.html',
          name: 'Quản lý thiết bị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách thiết bị',
              component: DeviceList
            }
          ]
        },
        {
          path: '/files-screen-management',
          redirect: '/files-screen-management/managed-files.html',
          name: 'Quản lý nội dung bảng điện tử',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-files.html',
              name: 'Nội dung bảng điện tử đã biên tập',
              component: ScreenFileList
            },
            {
              path: 'upload-screen.html',
              name: 'Biên tập nội dung bảng điện tử',
              component: ScreenFileAdd,
            },
            {
              path: 'play-list.html',
              name: 'Biên tập danh sách phát',
              component: PlayList,
            },
            {
              path: 'play-list-add.html',
              name: 'Thêm mới danh sách phát',
              component: PlayListAdd,
            },
            {
              path: ':id/play-list-update.html',
              name: 'Cập nhật danh sách phát',
              component: PlayListUpdate,
            },
            {
              path: 'slide-show.html',
              name: 'Nội dung trình diễn',
              component: SlideShowList,
            },
            {
              path: 'slide-show-add.html',
              name: 'Thêm mới nội dung trình diễn',
              component: SlideShowAdd,
            },
            {
              path: ':id/slide-show-update.html',
              name: 'Cập nhật nội dung trình diễn',
              component: SlideShowUpdate,
            },
            {
              path: 'slide-show-central.html',
              name: 'Cấu hình nội dung trình diễn từ nguồn',
              component: ConfigSlideShowList,
            },
            {
              path: 'slide-show-central-add.html',
              name: 'Thêm mới cấu hình nội dung trình diễn từ nguồn',
              component: ConfigSlideShowAdd,
            },
            {
              path: ':id/slide-show-central-update.html',
              name: 'Cập nhật cấu hình nội dung trình diễn từ nguồn',
              component: ConfigSlideShowUpdate,
            }
          ]
        },
        {
          path: '/schedule-management',
          redirect: '/schedule-management/managed-shedule.html',
          name: 'Quản lý phát thanh',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-shedule.html',
              name: 'Lịch phát',
              component: ScheduleList
            },
            {
              path: 'schedule-add.html',
              name: 'Thêm lịch phát',
              component: ScheduleAdd
            },
            {
              path: ':id/managed-shedule-detail.html',
              name: 'Lịch phát chi tiết',
              component: ScheduleDetailList
            },
          ]
        },
        {
          path: '/history-management',
          redirect: '/history-management/managed-history.html',
          name: 'Nhật ký lịch phát',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-history.html',
              name: 'Danh sách nhật ký',
              component: HistoryList
            }
          ]
        },
        {
          path: '/administrator',
          redirect: '/administrator/user-activity-log.html',
          name: 'Quản trị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'user-activity-log.html',
              name: 'Nhật ký hoạt động',
              component: UserActionLogList
            },
            {
              path: 'pi-action-config.html',
              name: 'Quản lý thao tác Rashberry Pi',
              component: PiActionConfigList
            },
            {
              path: 'pi-action-config-add.html',
              name: 'Thêm thao tác Rashberry Pi',
              component: PiActionConfigAdd
            },
            {
              path: ':id/pi-action-config-update.html',
              name: 'Cập nhật thao tác Rashberry Pi',
              component: PiActionConfigUpdate
            },
            {
              path: 'thread.html',
              name: 'Tiến trình',
              component: ThreadList
            },
            {
              path: 'managed-org.html',
              name: 'Danh sách đơn vị',
              component: OrgList
            },
            {
              path: 'managed-org-add.html',
              name: 'Thêm mới đơn vị',
              component: OrgAdd
            },
            {
              path: ':id/managed-org.html',
              name: 'Thêm mới đơn vị',
              component: OrgUpdate
            },
            {
              path: 'managed-license.html',
              name: 'Danh sách license',
              component: LicenseList
            },
            {
              path: 'managed-license-add.html',
              name: 'Thêm mới license',
              component: LicenseAdd
            },
            {
              path: 'managed-widget.html',
              name: 'Danh sách tiện ích',
              component: WidgetList
            },
            {
              path: 'managed-widget-add.html',
              name: 'Thêm mới tiện ích',
              component: WidgetAdd
            },
            {
              path: ':id/managed-widget-update.html',
              name: 'Cập nhật tiện ích',
              component: WidgetUpdate
            },
            {
              path: ':id/managed-widget-org.html',
              name: 'Cập nhật đơn vị sử dụng tiện ích',
              component: WidgetOrg
            },
          ]
        },
        {
          path: '/user-management',
          redirect: '/user-management/managed-users',
          name: 'Quản lý tài khoản',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-users.html',
              name: 'Danh sách tài khoản',
              component: UsersList
            },
            {
              path: 'managed-position.html',
              name: 'Danh sách chức vụ',
              component: CategoryList
            },
            {
              path: 'new.html',
              name: 'Thêm mới tài khoản',
              component: UserAdd
            },
            {
              path: ':id/managed-user.html',
              name: 'Cập nhật tài khoản',
              component: UserUpdate
            },
            {
              path: 'my-profile.html',
              name: 'Thông tin tài khoản',
              component: UserProfile
            }
          ]
        },
        {
          path: '/notification-management',
          redirect: '/notification-management/managed-notification.html',
          name: 'Danh sách thông báo',
          meta: {
            requiresAuth: true,
          }
          ,
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-notification.html',
              name: 'Danh sách thông báo',
              component: NotificationList
            }
          ]
        }
      ]
    },
    {
      path: '/login.html',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/verify.html',
      name: 'UserVerifyOTP',
      component: UserVerifyOTP,
    },
    {
      path: '/register.html',
      name: 'UserRegister',
      component: UserRegister,
    },
    {
      path: '/user',
      name: 'user',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'reset-password.html',
          name: 'UserResetPass',
          component: UserResetPass
        }
      ]
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        },
        {
          path: 'pending-config',
          name: 'pendingConfig',
          component: PageNoConfigUser
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },

  ]
})

export default router
